import { Grid2, Typography } from "@mui/material";
import PermissionsSelect from "./PermissionsSelect";
import CollapseGrid from "../../../../../UI/GeneralPurpose/CollapseGrid";
import ChangePermissions, { changePermissionsUI } from "./ChangePermissions";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";

const UIText = {
  "es-CL": { label: "Permisos" },
  "en-US": { label: "Permissions" },
};

const Permissions = ({ isNew, users }) => {
  const { UI, settings } = useUIBp();
  const changePermissions = UI[changePermissionsUI];
  const locale = settings.locale;
  const { label } = UIText[locale];

  return (
    <Grid2 container size={12}>
      {users.length > 1 ? (
        <ChangePermissions {...{ locale }} />
      ) : (
        <Grid2 container size={12}>
          <Typography fontWeight="bold">{label}</Typography>
        </Grid2>
      )}
      <CollapseGrid
        open={changePermissions || users.length === 1 || isNew}
        outerProps={{ size: 12 }}
        innerProps={{ paddingTop: 1 }}
      >
        <PermissionsSelect />
      </CollapseGrid>
    </Grid2>
  );
};

export default Permissions;
